module.exports = __webpack_public_path__ + "funding3-83cdbd12c4c3c5bd5d4d69b793ec6b71.png";